import React from 'react';
import { Navigate } from 'react-router-dom';
import EllisAiDntChat from './EllisAiDntChat';
import { useFeatureFlags } from '../../hooks/useFeatureFlags';

/**
 * Wrapper component for Ellis AI D&T Chat
 */
const EllisAiDntChatWrapper: React.FC = () => {
  const { sidebarFeatures, isReady } = useFeatureFlags();

  if (!isReady) {
    return null;
  }

  const isEllisAiChatEnabled = sidebarFeatures.includes('Ellis AI D&T Chat');

  if (!isEllisAiChatEnabled) {
    return <Navigate to="/" replace />;
  }

  return <EllisAiDntChat />;
};

export default EllisAiDntChatWrapper;
